import { WorkbenchService } from '@affine/core/modules/workbench';
import { useLiveData, useService } from '@toeverything/infra';

import { MenuLinkItem } from '../../modules/app-sidebar/views';

/**
 * Sidebar shortcut to the template gallery («Шаблоны») — the Notion-style
 * page of ready-made pages, built on the page builder.
 */
export const TemplatesButton = () => {
  const workbench = useService(WorkbenchService).workbench;
  const location = useLiveData(workbench.location$);
  const active = location.pathname.startsWith('/templates');

  return (
    <MenuLinkItem
      data-testid="templates-button"
      active={active}
      to={'/templates'}
      icon={
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          aria-hidden="true"
        >
          <rect
            x="2.5"
            y="2.5"
            width="11"
            height="11"
            rx="2.5"
            stroke="currentColor"
            strokeWidth="1.4"
          />
          <path
            d="M5 6h6M5 8.5h6M5 11h3.5"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
          />
        </svg>
      }
    >
      Шаблоны
    </MenuLinkItem>
  );
};
